import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react"

const Disclaimer = ({ message }) => {
  const [isVisible, setIsVisible] = useState(sessionStorage.getItem("clearDisclaimer") !== "YES");

  if (!isVisible) return null;

  return (
    <div className={`bg-white border-y border-gray-300 px-4 py-2 flex items-center justify-between`}>
      <div className="flex items-center gap-x-2 overflow-hidden w-[calc(100dvw-3.5rem)]">
        <div className='text-sm font-medium marquee text-indigo-950 w-full'>{message}</div>
      </div>
      <button onClick={() => {setIsVisible(false);sessionStorage.setItem('clearDisclaimer','YES')}} className="text-sm font-medium">
        <XMarkIcon className="h-4 w-4" />
        <span className="sr-only">Dismiss</span>
      </button>
    </div>
  )
}

export default Disclaimer